import {
  initFooter,
  initLangAction,
  initLangCookie,
  initResponsivecMenu,
} from "./common";

var lang;
$(document).ready(function () {
  $(function () {
    initFooter();
    initLangUi();
    initLs();
  });
});

function initLangUi() {
  lang = initLangCookie();
  console.log("projects: lang = " + lang);
  initLangAction();
}

function initLs() {
  initResponsivecMenu();
}
